var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-wallet-item"},[_c('span',{staticClass:"skeleton",staticStyle:{"width":"50%"}},[_vm._v("test")]),_vm._v(" "),_c('div',{staticClass:"widget-wallet-data"},[_c('span',{staticClass:"skeleton"},[_vm._v("testtetetest")])])])
}]

export { render, staticRenderFns }